import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, getHallManagerWorkUpdatationListUrl, GET_HALL_MANAGER_WORK_UPDATION_LIST, UPDATE_HALL_MANAGER_WORK_UPDATION_LIST, updateHallManagerWorkUpdatationListUrl, getWorkUpdationLogListUrl, GET_WORK_UPDATION_LOG_LIST, GET_VENDOR_STAFF_LIST, getVendorStaffListUrl } from "../../../utils/constants";


export const getHallManagerWorkUpdatationList_action = (AccountID, ZoneID, ExhRegistrationCompany, VendorRegistrationCompany, StatusID, HallID, ExhRegistrationNo, ExhibitionOtherAreaID, PossessionStatusID, ServiceID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            AccountID: sessionStorage.getItem("RoleIDSS") == 16 || sessionStorage.getItem("RoleIDSS") == 20 ? sessionStorage.getItem("AccountIDSS") : null,
            ZoneID: ZoneID != '' ? ZoneID : null,
            ExhRegistrationCompany: ExhRegistrationCompany != '' ? ExhRegistrationCompany : null,
            VendorRegistrationCompany: VendorRegistrationCompany != '' ? VendorRegistrationCompany : null,
            StatusID: StatusID != '' ? StatusID : null,
            HallID: HallID != '' ? HallID : null,
            ExhRegistrationNo: ExhRegistrationNo != '' ? ExhRegistrationNo : null,
            ExhibitionOtherAreaID: ExhibitionOtherAreaID != '' ? ExhibitionOtherAreaID : null,
            PossessionStatusID: PossessionStatusID != '' ? PossessionStatusID : null,
            ServiceID: ServiceID != '' ? ServiceID : null,
        }

        const res = await axiosGet(getHallManagerWorkUpdatationListUrl, params, headers)

        dispatch({
            type: GET_HALL_MANAGER_WORK_UPDATION_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateHallManagerWorkUpdatationList_action = (HMWorkupdationList, IsHallManager, notify) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            AccountID: sessionStorage.getItem("AccountIDSS"),
            HMWorkupdationList: HMWorkupdationList,
            IsHallManager: sessionStorage.getItem('RoleIDSS') == 16,
            /* Which tier moved, and which way. The posted row carries every column,
               so the API cannot tell a verification from a remark edit on its own.
               Left out by every other save path, which therefore notifies nobody */
            NotifyEventTypeID: notify ? notify.EventTypeID : null,
            NotifyIsPositive: notify ? notify.IsPositive : null,
        }

        const res = await axiosPost(updateHallManagerWorkUpdatationListUrl, params, headers)

        dispatch({
            type: UPDATE_HALL_MANAGER_WORK_UPDATION_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getWorkUpdationLogList_action = (HMWorkupdationID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            HMWorkupdationID: HMWorkupdationID,
        }

        const res = await axiosGet(getWorkUpdationLogListUrl, params, headers)

        dispatch({
            type: GET_WORK_UPDATION_LOG_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getVendorStaffList_action = (VendorID, ServiceID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            VendorID: VendorID,
            ServiceID: ServiceID,
        }

        const res = await axiosGet(getVendorStaffListUrl, params, headers)

        dispatch({
            type: GET_VENDOR_STAFF_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}